import { render, staticRenderFns } from "./base-field-file-input.vue?vue&type=template&id=d7b97be6&"
import script from "./base-field-file-input.vue?vue&type=script&lang=js&"
export * from "./base-field-file-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports